<script setup>
const props = defineProps({
  modelValue: { type: Boolean, default: false },
  initialSection: { type: String, default: "terms" },
})

const emit = defineEmits(["update:modelValue"])
const activeSection = ref(props.initialSection)

const closeDialog = () => emit("update:modelValue", false)

watch(() => props.initialSection, value => {
  activeSection.value = value
})

watch(() => props.modelValue, value => {
  if (value) activeSection.value = props.initialSection
})
</script>

<template>
  <VDialog
    :model-value="modelValue"
    max-width="680"
    width="calc(100% - 24px)"
    :z-index="2600"
    scrollable
    persistent
    @update:model-value="value => emit('update:modelValue', value)"
  >
    <VCard class="legal-dialog" dir="rtl">
      <header class="legal-dialog__header">
        <div class="legal-dialog__heading">
          <span class="legal-dialog__icon">
            <VIcon icon="tabler-shield-lock" size="24" />
          </span>
          <div>
            <span>الومنشی؛ همراه مطمئن رزروهای شما</span>
            <h2>قوانین استفاده و حریم خصوصی</h2>
          </div>
        </div>

        <button type="button" aria-label="بستن" @click="closeDialog">
          <VIcon icon="tabler-x" size="21" />
        </button>
      </header>

      <VTabs v-model="activeSection" grow class="legal-dialog__tabs">
        <VTab value="terms">
          <VIcon icon="tabler-file-description" size="18" />
          شرایط و مقررات
        </VTab>
        <VTab value="privacy">
          <VIcon icon="tabler-lock" size="18" />
          حریم خصوصی
        </VTab>
      </VTabs>

      <VCardText class="legal-dialog__content">
        <VWindow v-model="activeSection" :touch="false">
          <VWindowItem value="terms">
            <article class="legal-copy">
              <div class="legal-copy__intro">
                <VIcon icon="tabler-info-circle" size="19" />
                <p>استفاده از الومنشی به معنی آگاهی و پذیرش این شرایط است. لطفاً پیش از ثبت رزرو، اطلاعات خدمت و قوانین کسب‌وکار ارائه‌دهنده را نیز بررسی کنید.</p>
              </div>

              <section>
                <span>۱</span>
                <div><h3>نقش الومنشی</h3><p>الومنشی بستری برای مشاهده خدمات، انتخاب زمان و ارتباط میان کاربران و کسب‌وکارهاست. ارائه و کیفیت خدمت بر عهده کسب‌وکار ارائه‌دهنده است.</p></div>
              </section>
              <section>
                <span>۲</span>
                <div><h3>حساب کاربری</h3><p>برای ورود و پیگیری رزروها باید شماره موبایل صحیح و در دسترس وارد شود. حفاظت از کد تأیید و فعالیت‌های انجام‌شده با حساب بر عهده کاربر است.</p></div>
              </section>
              <section>
                <span>۳</span>
                <div><h3>رزرو، تغییر و لغو</h3><p>زمان، مبلغ، شرایط تغییر یا لغو و سایر جزئیات هر خدمت پیش از تأیید نمایش داده می‌شود. این شرایط ممکن است با توجه به سیاست هر کسب‌وکار متفاوت باشد.</p></div>
              </section>
              <section>
                <span>۴</span>
                <div><h3>رفتار مسئولانه</h3><p>ثبت اطلاعات نادرست، ایجاد اختلال، دسترسی غیرمجاز، سوءاستفاده از حساب دیگران و انتشار محتوای خلاف قانون یا ناقض حقوق اشخاص مجاز نیست.</p></div>
              </section>
              <section>
                <span>۵</span>
                <div><h3>نظرها و محتوای کاربران</h3><p>نظرها باید بر پایه تجربه واقعی، محترمانه و مرتبط با خدمت باشند. محتوای نامرتبط، توهین‌آمیز یا ناقض حریم دیگران می‌تواند بررسی یا حذف شود.</p></div>
              </section>
              <section>
                <span>۶</span>
                <div><h3>به‌روزرسانی شرایط</h3><p>ممکن است این متن هم‌زمان با توسعه خدمات اصلاح شود. نسخه جدید از طریق همین بخش در دسترس خواهد بود.</p></div>
              </section>
            </article>
          </VWindowItem>

          <VWindowItem value="privacy">
            <article class="legal-copy">
              <div class="legal-copy__intro legal-copy__intro--privacy">
                <VIcon icon="tabler-eye-shield" size="19" />
                <p>شفافیت برای ما مهم است. در این بخش توضیح می‌دهیم چه داده‌هایی برای ارائه خدمات پردازش می‌شوند و در چه مواردی در اختیار طرف‌های ضروری قرار می‌گیرند.</p>
              </div>

              <section>
                <span>۱</span>
                <div><h3>اطلاعاتی که دریافت می‌شود</h3><p>شماره موبایل و اطلاعات حساب، مشخصات و سوابق رزرو، ارتباطات پشتیبانی و داده‌های فنی لازم برای امنیت و عملکرد سامانه پردازش می‌شوند. موقعیت مکانی فقط در صورت استفاده از قابلیت مربوط و دادن دسترسی دریافت می‌شود.</p></div>
              </section>
              <section>
                <span>۲</span>
                <div><h3>هدف استفاده از اطلاعات</h3><p>این اطلاعات برای ورود امن، ثبت و مدیریت رزرو، اطلاع‌رسانی وضعیت، پشتیبانی، پیشگیری از سوءاستفاده و بهبود تجربه کاربری استفاده می‌شوند.</p></div>
              </section>
              <section>
                <span>۳</span>
                <div><h3>اشتراک‌گذاری ضروری</h3><p>اطلاعات لازم برای انجام رزرو با کسب‌وکار منتخب به اشتراک گذاشته می‌شود. همچنین ممکن است ارائه‌دهندگان زیرساخت، پیامک یا پرداخت، فقط در محدوده ارائه خدمت مربوط، داده لازم را پردازش کنند.</p></div>
              </section>
              <section>
                <span>۴</span>
                <div><h3>نگهداری و امنیت</h3><p>برای حفاظت از اطلاعات از کنترل‌های فنی و اجرایی متناسب استفاده می‌شود. اطلاعات تا زمانی نگهداری می‌شوند که برای ارائه خدمت، رسیدگی به درخواست‌ها یا الزامات قانونی لازم باشند.</p></div>
              </section>
              <section>
                <span>۵</span>
                <div><h3>انتخاب‌ها و درخواست‌های شما</h3><p>می‌توانید اطلاعات قابل ویرایش حساب را اصلاح کنید و برای پرسش درباره داده‌ها یا ثبت درخواست مرتبط با حریم خصوصی، از مسیرهای پشتیبانی الومنشی با ما در ارتباط باشید.</p></div>
              </section>
              <section>
                <span>۶</span>
                <div><h3>کوکی و حافظه مرورگر</h3><p>برای حفظ وضعیت ورود، امنیت و عملکرد صحیح بخش‌های ضروری سامانه ممکن است از کوکی یا حافظه مرورگر استفاده شود.</p></div>
              </section>
            </article>
          </VWindowItem>
        </VWindow>
      </VCardText>

      <VCardActions class="legal-dialog__actions">
        <p><VIcon icon="tabler-calendar-check" size="17" />آخرین بازنگری: مرداد ۱۴۰۵</p>
        <VBtn color="primary" rounded="lg" variant="elevated" @click="closeDialog">متوجه شدم</VBtn>
      </VCardActions>
    </VCard>
  </VDialog>
</template>

<style lang="scss" scoped>
.legal-dialog { overflow: hidden; border: 1px solid rgba(var(--v-theme-primary),.1); border-radius: 22px !important; background: #fff; box-shadow: 0 24px 70px rgba(42,34,78,.2); }
.legal-dialog__header { display: flex; align-items: center; justify-content: space-between; gap: 16px; padding: 22px 24px 17px; background: linear-gradient(135deg,rgba(var(--v-theme-primary),.08),rgba(201,167,78,.09)); }
.legal-dialog__heading { display: flex; align-items: center; gap: 12px; }
.legal-dialog__icon { display: grid; width: 44px; height: 44px; flex: 0 0 44px; place-items: center; border-radius: 14px; background: #fff; color: rgb(var(--v-theme-primary)); box-shadow: 0 7px 20px rgba(42,34,78,.09); }
.legal-dialog__heading span { color: rgba(var(--v-theme-on-surface),.52); font-size: 9px; }
.legal-dialog__heading h2 { margin: 4px 0 0; color: #302a42; font-size: 17px; }
.legal-dialog__header > button { display: grid; width: 34px; height: 34px; flex: 0 0 34px; place-items: center; border: 0; border-radius: 50%; background: rgba(var(--v-theme-on-surface),.06); color: rgba(var(--v-theme-on-surface),.65); cursor: pointer; }
.legal-dialog__tabs { border-block: 1px solid rgba(var(--v-theme-on-surface),.07); }
.legal-dialog__tabs :deep(.v-btn) { gap: 7px; font-size: 11px; font-weight: 700; letter-spacing: 0; }
.legal-dialog__content { max-height: min(58vh,520px); padding: 21px 24px !important; }
.legal-copy { display: grid; gap: 17px; }
.legal-copy__intro { display: flex; align-items: flex-start; gap: 9px; padding: 12px 13px; border: 1px solid rgba(var(--v-theme-primary),.1); border-radius: 12px; background: rgba(var(--v-theme-primary),.045); color: rgb(var(--v-theme-primary)); }
.legal-copy__intro--privacy { border-color: rgba(201,167,78,.18); background: rgba(201,167,78,.07); color: #8d6e20; }
.legal-copy__intro p { margin: 0; color: rgba(var(--v-theme-on-surface),.65); font-size: 9px; line-height: 2; }
.legal-copy section { display: flex; align-items: flex-start; gap: 11px; }
.legal-copy section > span { display: grid; width: 25px; height: 25px; flex: 0 0 25px; place-items: center; border-radius: 8px; background: rgba(var(--v-theme-primary),.075); color: rgb(var(--v-theme-primary)); font-size: 9px; font-weight: 800; }
.legal-copy h3 { margin: 1px 0 4px; color: #383149; font-size: 11px; }
.legal-copy section p { margin: 0; color: rgba(var(--v-theme-on-surface),.58); font-size: 9px; line-height: 2; }
.legal-dialog__actions { display: flex; justify-content: space-between; gap: 14px; padding: 14px 24px !important; border-top: 1px solid rgba(var(--v-theme-on-surface),.07); background: #fff; }
.legal-dialog__actions p { display: flex; align-items: center; gap: 5px; margin: 0; color: rgba(var(--v-theme-on-surface),.45); font-size: 8px; }
.legal-dialog__actions :deep(.v-btn) { min-width: 118px; font-size: 10px; font-weight: 700; }
@media (max-width:600px) {
  .legal-dialog { border-radius: 20px 20px 0 0 !important; }
  .legal-dialog__header { padding: 18px 17px 14px; }
  .legal-dialog__heading h2 { font-size: 15px; }
  .legal-dialog__content { max-height: 61vh; padding: 18px 17px !important; }
  .legal-dialog__actions { padding: 12px 17px calc(12px + env(safe-area-inset-bottom)) !important; }
  .legal-dialog__actions p { display: none; }
  .legal-dialog__actions :deep(.v-btn) { width: 100%; }
}
</style>
